module.exports = __webpack_public_path__ + "img/0-16.bdfbbb5b.gif";